<template>
  <div class="card">
    <div class="card-body">
      <div
        v-if="loading"
        class="d-flex align-items-center justify-content-center py-1"
      >
        <img src="@/assets/loaderPrimary.svg" height="75" alt="" />
      </div>
      <div
        v-else
        class="d-flex align-items-center justify-content-between py-1"
      >
        <div>
          <h3>{{ name }}</h3>
          <h2>{{ quantity }}</h2>
        </div>
        <v-icon name="bi-cart2" scale="2" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TotalSales",
  props: {
    name: String,
    quantity: Number,
    loading: Boolean,
  },
};
</script>
<style lang="scss" scoped>
.card {
  border-radius: 10px;
}
</style>
